import { CustomDataAttrGtmClick } from '../../../features/google/customDataType';
import { DefaultProps } from '../../../types/DefaultProps';
import { FiChevronRightIcon } from '../../Icon';

import styles from './ButtonTitle.module.scss';

import type { FC } from 'react';

export type ButtonProps = DefaultProps & {
  linkText?: string;
  link?: string;
  customDataAttrGtmClick?: CustomDataAttrGtmClick;
};

export const ButtonTitle: FC<ButtonProps> = ({ linkText, link }) => (
  <a className={styles['button-white']} aria-label={linkText} href={link}>
    <span className={styles['button-text']}>{linkText}</span>
    <FiChevronRightIcon size={18} />
  </a>
);
